<template>
  <div class="row">
    <div class="col-12">
      <div class="col-md-12">
        <create-car-form v-if="showForm"
          :key="carToEdit ? carToEdit.id : 'new'"
          :edit-mode="editMode"
          :car="carToEdit"
          @close="closeForm"
          @refreshData="fetchData"
        >
        </create-car-form>
      </div>
      <card card-body-classes="table-full-width" :title="$t('cars.cars')" :on-add-object="openForm">
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="col-12 col-md-4 col-sm-6 mb-2">
              <el-input
                v-model="searchQuery"
                class="search-input"
                clearable
                :prefix-icon="Search"
                :placeholder="$t('common.searchRecords')"
                aria-controls="datatables"
                @keyup="search"
                @clear="handleClearSearch"
              />
            </div>
          </div>
          <el-base-table
            :table-data="cars"
            :table-columns="tableColumns"
            :enable-edit="true"
            :enable-delete="true"
            :actions-inline="true"
            :allow-click="true"
            @row-click="goToCar"
            @edit="handleEdit"
            @delete="handleDelete" />
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap pagination"
          >
            <div class="">
              <p class="card-category">
                {{ $t('pagination.showing') }} {{ from + 1 }} {{ $t('pagination.to') }} {{ to }} {{ $t('pagination.of') }} {{ total }} {{ $t('pagination.entries') }}
              </p>
            </div>
            <material-pagination color="info" class="pagination-no-border">
              <material-pagination-item
                prev
                :disabled="pagination.currentPage === 1"
                @click="prevPage"
              />
              <material-pagination-item
                v-for="page in displayedPages"
                :key="page"
                :label="String(page)"
                :active="pagination.currentPage === page"
                @click="changePage(page)"
              />
              <material-pagination-item
                next
                :disabled="pagination.currentPage === totalPages"
                @click="nextPage"
              />
            </material-pagination>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import api from "../../services/api"
import CreateCarForm from "./CreateCarForm";
import MaterialPagination from '../../components/MaterialPagination.vue';
import MaterialPaginationItem from '../../components/MaterialPaginationItem.vue';
import ElBaseTable from '../../components/ElBaseTable.vue';
import swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { getCustomerConfig } from '../Settings/customerConfigHelper';
import { Search } from '@element-plus/icons-vue';
import Card from "../../components/Card.vue";
import { VEHICLE_CATEGORIES, labelKeyFor, formatDate } from './carHelper';

export default {
components: {
    CreateCarForm,
    MaterialPagination,
    MaterialPaginationItem,
    'el-base-table': ElBaseTable,
    Card
},

data() {
    return {
      Search,
      showForm: false,
      editMode: false,
      carToEdit: null,
      cars: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      tableColumns: [
        { prop: 'name', label: this.$t('common.name'), minWidth: 200 },
        { prop: 'licencePlate', label: this.$t('cars.licencePlate'), minWidth: 200 },
        { prop: 'category', label: this.$t('cars.category'), minWidth: 150 },
        { prop: 'nextInspection', label: this.$t('cars.nextInspection'), minWidth: 130 },
        { prop: 'numberOfTools', label: this.$t('cars.numberOfTools'), minWidth: 100 },
        { prop: 'reservedBy', label: this.$t('cars.reservedBy'), minWidth: 200 },
        { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true,
          compound: {
            'common.name': 'name', 'cars.licencePlate': 'licencePlate', 'cars.nextInspection': 'nextInspection', 'cars.numberOfTools': 'numberOfTools'
          }
        }
      ],
      searchQuery: '',
      isMobile: window.innerWidth <= 1024,
      initalPage: true
    };
},
computed: {
  to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
      highBound = this.total;
    }
    return highBound;
  },
  from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1);
  },
  total() {
    return this.pagination.total;
  },
  totalPages() {
    if (this.total > 0) {
      return Math.ceil(this.total / this.pagination.perPage);
    }
    return 1;
  },
  displayedPages() {
    const pages = [];
    const maxPages = Math.min(5, this.totalPages);

    let startPage = Math.max(1, this.pagination.currentPage - Math.floor(maxPages / 2));
    let endPage = startPage + maxPages - 1;

    if (endPage > this.totalPages) {
      endPage = this.totalPages;
      startPage = Math.max(1, endPage - maxPages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }
  },
created() {
  const savedSearchQuery = Cookies.get('carsSearchQuery');
  if (savedSearchQuery) {
    this.searchQuery = savedSearchQuery;
  } else {
    this.searchQuery = '';
  }

  const savedPage = Cookies.get('carsPage');
  if (savedPage) {
    this.pagination.currentPage = Number(savedPage);
  } else {
    this.pagination.currentPage = 1
  }

  getCustomerConfig('DefaultPageSize')
    .then(config => {
      if(config === '')
      {
        this.pagination.perPage = 10
      }
      else
      {
        this.pagination.perPage = config
      }
        this.fetchData();
    })
    window.addEventListener('resize', this.updateIsMobile);
},
beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
},
methods: {
updateIsMobile() {
    this.isMobile = window.innerWidth <= 1024;
},
updatePage(item){
  this.pagination.currentPage = item;
  Cookies.set('carsPage', this.pagination.currentPage, { expires: new Date(new Date().getTime() + 1 * 60 * 1000) });
  this.fetchData()
},
changePage(page) {
  if (page !== this.pagination.currentPage && page >= 1 && page <= this.totalPages) {
    this.pagination.currentPage = page;
    Cookies.set('carsPage', this.pagination.currentPage, { expires: new Date(new Date().getTime() + 1 * 60 * 1000) });
    this.fetchData();
  }
},
nextPage() {
  if (this.pagination.currentPage < this.totalPages) {
    this.changePage(this.pagination.currentPage + 1);
  }
},
prevPage() {
  if (this.pagination.currentPage > 1) {
    this.changePage(this.pagination.currentPage - 1);
  }
},
search(event){
  const queryLength = this.searchQuery.length;
  this.pagination.currentPage = 1;

  if (event.key === 'Backspace' || event.key === 'Enter') {
    this.fetchData();
  }
  else {
    if (queryLength > 1) {
      if (queryLength % 2 === 0) {
        this.fetchData();
      }
    }
  }
},
handleClearSearch()
{
    Cookies.remove('carsPage');
    this.pagination.currentPage = 1
    this.fetchData();
},
handleEdit(index, row) {
  this.editMode = true;

  let toolGroupUrl = `/ToolGroup/${row.id}`;
      api.get(toolGroupUrl)
        .then(response => {
          this.carToEdit = response.data;
          this.openForm();
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 })
        });
},
handleDelete(index, row){
  swal.fire({
    title: this.$t('delete.areYouSure'),
    text: this.$t('delete.noRevert'),
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'btn btn-success btn-fill',
      cancelButton: 'btn btn-danger btn-fill'
    },
    confirmButtonText: this.$t('delete.yesDeleteIt'),
    cancelButtonText: this.$t('delete.cancel'),
    buttonsStyling: false
  }).then(result => {
    if (result.value) {
      this.deleteToolGroup(row);
    }
  });
},
deleteToolGroup(row)
{
  let deleteUrl = `/ToolGroup/` + row.id
  api.delete(deleteUrl)
  .then(() => {
    this.cars = this.cars.filter(car => car.id !== row.id);
    swal.fire({
      title: this.$t('delete.deleted'),
      text: `${this.$t('delete.youDeleted')} ${row.name}`,
      icon: 'success',
      customClass: {
        confirmButton: 'btn btn-success btn-fill',
      },
      buttonsStyling: false
    });
  })
  .catch(error => {
    console.error('API request error:', error); // eslint-disable-line no-console
    this.$toast.error(this.$t('common.unableToDelete'), { timeout: 0 })
  });
},
openForm()
{
  this.showForm = true;
  this.$nextTick(() => {
    window.scrollTo(0, 0);
  });
},
closeForm()
{
  this.showForm = false;
  this.editMode = false;
  this.carToEdit = null;
},
goToCar(item) {
  this.$router.push({ name: 'Car', params: { toolGroupId: item.id.toString() } });
},
fetchData() {
    let getToolGroupUrl  = ''
    if(this.searchQuery === '')
    {
        Cookies.remove('carsSearchQuery');
        getToolGroupUrl = `/ToolGroup?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&toolGroupTypeId=1`
    }
    else
    {
      Cookies.set('carsSearchQuery', this.searchQuery, { expires: new Date(new Date().getTime() + 1 * 60 * 1000) });
      getToolGroupUrl = `/ToolGroup?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&toolGroupTypeId=1&searchString=${this.searchQuery}`
    }
    api.get(getToolGroupUrl)
    .then(response => {
        this.pagination.total = response.data.totalItems;
        this.cars = response.data.result.map(item => {
          let numberOfTools = 0
          numberOfTools = item.toolToToolGroupsCount
          let reservedBy = ''
          if(item.toolGroupReservations.filter(p => p.isReserved === true) && item.toolGroupReservations.filter(p => p.isReserved === true).length > 0)
          {
            reservedBy = item.toolGroupReservations.filter(p => p.isReserved === true)[0].user.firstName + ' ' + item.toolGroupReservations.filter(p => p.isReserved === true)[0].user.lastName
          }
          let licencePlate = ''
          if(item.toolGroupProperties.filter(p => p.key === 'licencePlate'))
          {
            licencePlate = item.toolGroupProperties.filter(p => p.key === 'licencePlate')[0].value
          }
          return {
              id: item.id,
              name: item.name,
              reservedBy: reservedBy,
              licencePlate: licencePlate,
              category: item.vehicleCategory ? this.$t(labelKeyFor(VEHICLE_CATEGORIES, item.vehicleCategory)) : '',
              nextInspection: formatDate(item.nextInspectionDate),
              numberOfTools: numberOfTools
          };
        });
    })
    .catch(error => {
      console.error('API request error:', error); // eslint-disable-line no-console
      this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 })
    });
    },
},
};
</script>
<style></style>
